import { render, staticRenderFns } from "./BpCheckbox.vue?vue&type=template&id=d6ad5b92&scoped=true&"
import script from "./BpCheckbox.vue?vue&type=script&lang=js&"
export * from "./BpCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./BpCheckbox.vue?vue&type=style&index=0&id=d6ad5b92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6ad5b92",
  null
  
)

export default component.exports